import React, { useState, useEffect } from 'react';
import { CSVLink } from 'react-csv';
import axios from 'axios';
import { useUser } from '../context/UserContext';
import Select from 'react-select';
import { FiChevronDown, FiRefreshCw } from 'react-icons/fi';

const CheckinReports = () => {
  const token = localStorage.getItem('auth-token');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedAcademy, setSelectedAcademy] = useState('');
  const { selectedCenter, userData } = useUser();
  const getFormattedDate = (date) => date.toISOString().split('T')[0];
  const today = new Date();
  const tenDaysAgo = new Date();
  tenDaysAgo.setDate(today.getDate() - 0);
  const [fromDate, setFromDate] = useState(getFormattedDate(tenDaysAgo));
  const [toDate, setToDate] = useState(getFormattedDate(today));
  const [selectedType, setSelectedType] = useState([]);
  const [selectedSport, setSelectedSport] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('');
  const [rowsPerPage, setrowsPerPage] = useState(10);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (selectedCenter) {
      setSelectedAcademy(Number(selectedCenter));
    }
  }, [selectedCenter]);

  const handleItemsPerPageChange = (event) => {
    setrowsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const [CheckinReports, setCheckinReports] = useState([]);

  const [academyNames, setAcademyNames] = useState({});


  const fetchCheckinReports = async () => {
    setError('')
    setLoading(true);

    const headers = {
      'Authorization': `Bearer ${token}`,
    };

    const requestBody = {
      fromDate,
      toDate,
    };

    try {
      const response = await axios.post(
        process.env.REACT_APP_API_ACADEMY_CHECKIN_TRIALS,
        requestBody,
        { headers }
      );

      if (!response.data.success) {
        throw new Error(response.data.success_message || 'Unknown error');
      }

      const { bookings, academyNameMap, sportNameMap, parentMobileNumber } = response.data.data;

      const reports = bookings.map((booking) => {
        const createdAt = new Date(booking.updatedAt);
        const utcMinutes = createdAt.getUTCHours() * 60 + createdAt.getUTCMinutes();
        const istMinutes = (utcMinutes + 330) % 1440; 
      
        return {
          id: booking.id,
          player_name: booking?.user?.name || '-',
          phoneNumber: booking?.user?.mobile_number || '-',
          type: booking?.checkInType || '-',
          sport: sportNameMap?.[booking.sportId] || '-',
          timeSort: istMinutes,
          time: createdAt.toLocaleTimeString('en-IN', {
            timeZone: 'Asia/Kolkata',
            hour12: true,
            hour: 'numeric',
            minute: '2-digit'
          }),     
          date: booking?.trialDate || '-',
          status: booking?.statusType || '-',
          preferredCenter: academyNameMap?.[booking.academyId] || '-',
          remark: booking?.remark || '-',
          parentPhoneNumber: parentMobileNumber?.[booking.id] || '-',
        };
      });

      setCheckinReports(reports);
      setAcademyNames(academyNameMap || {});
    } catch (error) {
      console.error("Check-in fetch error:", error);
      setError('Failed to load data: ' + (error.message || 'Unknown error'));
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchCheckinReports();
  }, [fromDate, toDate]);


  const headers = [
    { key: 'preferredCenter', label: 'Academy' },
    { key: 'player_name', label: 'Name' },
    { key: 'phoneNumber', label: 'Mobile Number' },
    { key: 'parentPhoneNumber', label: 'Parent Number' },
    { key: 'type', label: 'Type' },
    { key: 'date', label: 'Date' },
    { key: 'time', label: 'Time' },
    { key: 'remark', label: 'Remark' },
    { key: 'sport', label: 'Sport' },
    { key: 'status', label: 'Status' }
  ];


  const [currentPage, setCurrentPage] = useState(1);

  const resetPageToFirst = () => {
    setCurrentPage(1);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, selectedAcademy, fromDate, toDate]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  const handleSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const sortedRows = [...CheckinReports].sort((a, b) => {
    if (!sortConfig.key) return 0;
  
    let aValue = a[sortConfig.key];
    let bValue = b[sortConfig.key];

    if (sortConfig.key === 'time') {
      aValue = a.timeSort ?? 0;
      bValue = b.timeSort ?? 0;
    }

    if (sortConfig.key === 'date') {
      aValue = new Date(a.date).getTime();
      bValue = new Date(b.date).getTime();
    }
  
    if (aValue < bValue) return sortConfig.direction === 'ascending' ? -1 : 1;
    if (aValue > bValue) return sortConfig.direction === 'ascending' ? 1 : -1;
    return 0;
  });

  const filteredCheckinReports = sortedRows.filter((checkin) => {
    const matchesSearch = Object.values(checkin)
      .join(' ')
      .toLowerCase()
      .includes(searchTerm.toLowerCase());

    const academyId = Object.keys(academyNames).find(
      (id) => academyNames[id] === checkin.preferredCenter
    );

    const matchesUserAcademy =
      userData?.userType !== "ACADEMY" ||
      (Array.isArray(userData.academyIds) &&
        userData.academyIds.includes(Number(academyId)));
    const matchesAcademy =
      selectedAcademy === "" ||
      checkin.preferredCenter?.trim().toLowerCase() ===
      academyNames[selectedAcademy]?.trim().toLowerCase();

    const matchesDate =
      (fromDate === "" || new Date(checkin.date) >= new Date(fromDate)) &&
      (toDate === "" || new Date(checkin.date) <= new Date(toDate));

    const matchesType = selectedType.length === 0 || selectedType.includes(checkin.type);
    const matchesSport = selectedSport === "" || checkin.sport === selectedSport;
    const matchesStatus = selectedStatus === "" || checkin.status === selectedStatus;

    return (
      matchesSearch &&
      matchesUserAcademy &&
      matchesAcademy &&
      matchesDate &&
      matchesType &&
      matchesSport &&
      matchesStatus
    );
  });

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = filteredCheckinReports.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(filteredCheckinReports.length / rowsPerPage);

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prevPage) => prevPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage((prevPage) => prevPage - 1);
  };

  const generatePageNumbers = () => {
    const pages = [];
    const totalPagesToShow = 5;

    if (totalPages <= totalPagesToShow) {

      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {

      pages.push(1);
      if (currentPage > 3) pages.push('...');
      for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
        pages.push(i);
      }
      if (currentPage < totalPages - 2) pages.push('...');
      pages.push(totalPages);
    }
    return pages;
  };
  const getCheckinsForSelectedAcademy = () => {
    return CheckinReports.filter((checkin) => {
      const academyId = Object.keys(academyNames).find(
        (id) => academyNames[id] === checkin.preferredCenter
      );

      if (selectedAcademy === '') return true;
      return Number(academyId) === Number(selectedAcademy);
    });
  };

  const renderPagination = () => {
    return generatePageNumbers().map((page, index) =>
      typeof page === 'number' ? (
        <button
          key={index}
          className={`page-number ${currentPage === page ? 'active' : ''}`}
          onClick={() => handlePageClick(page)}
        >
          {page}
        </button>
      ) : (
        <span key={index} className="pagination-dots">
          {page}
        </span>
      )
    );
  };

  const typeOptions = [...new Set(CheckinReports.map((checkin) => checkin.type))].filter(type => type !== '-');
  const sportOptions = [
    ...new Set(getCheckinsForSelectedAcademy().map((checkin) => checkin.sport))
  ].filter(sport => sport !== '-');

  const statusOptions = [...new Set(CheckinReports.map((checkin) => checkin.status))].filter(status => status !== '-');

  const academyOptions = userData?.userType === "ACADEMY"
    ? userData.academyIds.map(id => ({
      value: Number(id),
      label: academyNames[id] || `Academy ${id}`,
    }))
    : Object.keys(academyNames).map(id => ({
      value: Number(id),
      label: academyNames[id],
    }));

  const totalEntries = filteredCheckinReports.length;
  const indexOfFirstEntry = totalEntries > 0 ? (currentPage - 1) * rowsPerPage + 1 : 0;
  const indexOfLastEntry = totalEntries > 0 ? Math.min(currentPage * rowsPerPage, totalEntries) : 0;

  const getAcademyOptions = () => {
    return [...academyOptions];
  };

  const typeOptionsFormatted = typeOptions.map(type => ({ value: type, label: type }));
  const sportOptionsFormatted = sportOptions.map(sport => ({ value: sport, label: sport }));
  const statusOptionsFormatted = statusOptions.map(status => ({ value: status, label: status }));

  return (
    <div className="enrollment-container">
      <div className="sales-filters-login">
        <div className="floating-select" >
          <Select
            id="academySelect"
            className={`sales-filter-court-booking ${selectedAcademy ? "has-value" : ""}`}
            options={getAcademyOptions()}
            value={academyOptions.find(option => option.value === selectedAcademy) || null}
            onChange={(selectedOption) => {
              setSelectedAcademy(selectedOption ? selectedOption.value : '');
              resetPageToFirst();
            }}
            placeholder="Academy"
            isClearable
            menuPortalTarget={document.body}
            styles={{
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
          />
          {selectedAcademy && <label htmlFor="academySelect">Academy</label>}
        </div>

        <div className="floating-select">
          <input
            type="date"
            id="fromDate"
            className={`sales-filter-academy ${fromDate ? "has-value" : ""}`}
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            onClick={(e) => e.target.showPicker()}
            max={new Date().toISOString().split('T')[0]}
          />
          {fromDate && <label htmlFor="fromDate">Start Date</label>}
        </div>

        <div className="floating-select">
          <input
            type="date"
            id="toDate"
            className={`sales-filter-academy ${toDate ? "has-value" : ""}`}
            value={toDate}
            placeholder="dd/mm/yyyy"
            onChange={(e) => setToDate(e.target.value)}
            onClick={(e) => e.target.showPicker()}
            max={new Date().toISOString().split('T')[0]}
          />

          {toDate && <label htmlFor="toDate">End Date</label>}
        </div>

        <div className="floating-select" >
          <Select
            id="selectSport"
            className={`sales-filter-court-booking ${selectedSport ? "has-value" : ""}`}
            options={sportOptionsFormatted}
            value={sportOptionsFormatted.find(option => option.value === selectedSport) || null}
            onChange={(selectedOption) => {
              setSelectedSport(selectedOption ? selectedOption.value : '');
              resetPageToFirst();
            }}
            placeholder="Select Sport"
            isClearable
            menuPortalTarget={document.body}
            styles={{
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
          />
          {selectedSport && <label htmlFor="selectSport">Sport</label>}
        </div>

        <div className="floating-select">
          <Select
            id="selectStatus"
            className={`sales-filter-court-booking ${selectedStatus ? "has-value" : ""}`}
            options={statusOptionsFormatted}
            value={statusOptionsFormatted.find(option => option.value === selectedStatus) || null}
            onChange={(selectedOption) => {
              setSelectedStatus(selectedOption ? selectedOption.value : '');
              resetPageToFirst();
            }}
            placeholder="All Status"
            isClearable
            menuPortalTarget={document.body}
            styles={{
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
          />
          {selectedStatus && <label htmlFor="selectStatus">Status</label>}
        </div>

        <div className="floating-select">
          <Select
            id="typeSelect"
            className={`sales-filter-court-booking ${selectedType.length ? "has-value" : ""}`}
            options={typeOptionsFormatted}
            value={typeOptionsFormatted.filter(option => selectedType.includes(option.value))}
            onChange={(selectedOptions) => {
              const values = selectedOptions ? selectedOptions.map(option => option.value) : [];
              setSelectedType(values);
              resetPageToFirst();
            }}
            isMulti
            isClearable
            placeholder="Type"
            menuPortalTarget={document.body}
            styles={{
              container: (provided) => ({
                ...provided,
                display: 'inline-block',
                width: 'auto',
                minWidth: '25%',
                maxWidth: '100%',
              }),
              valueContainer: (provided) => ({
                ...provided,
                flexWrap: 'nowrap',
              }),
              multiValue: (provided) => ({
                ...provided,
                marginRight: '4px',
              }),
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
            }}
          />
          {selectedType.length > 0 && <label htmlFor="typeSelect">Type</label>}
        </div>
      </div>


      <div className="search-bar">
        <div className="input-container">
          <input
            type="text"
            id="searchInput"
            placeholder=""
            className={`search-input ${searchTerm ? "has-value" : ""}`}
            value={searchTerm}
            onChange={handleSearchChange}
          />
          <label htmlFor="searchInput" className="floating-label">
            🔍 Search
          </label>
        </div>

        <CSVLink
          data={filteredCheckinReports}
          headers={headers}
          filename="checkinReports.csv"
          className="btn btn-primary no-decoration"
        >
          <button className="csv_button" type="button" >
            <span
              className="button__text"

            >
              Export CSV
            </span>
            <span className="button__icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35" className="svg">
                <path d="M17.5,22.131a1.249,1.249,0,0,1-1.25-1.25V2.187a1.25,1.25,0,0,1,2.5,0V20.881A1.25,1.25,0,0,1,17.5,22.131Z"></path>
                <path d="M17.5,22.693a3.189,3.189,0,0,1-2.262-.936L8.487,15.006a1.249,1.249,0,0,1,1.767-1.767l6.751,6.751a.7.7,0,0,0,.99,0l6.751-6.751a1.25,1.25,0,0,1,1.768,1.767l-6.752,6.751A3.191,3.191,0,0,1,17.5,22.693Z"></path>
                <path d="M31.436,34.063H3.564A3.318,3.318,0,0,1,.25,30.749V22.011a1.25,1.25,0,0,1,2.5,0v8.738a.815.815,0,0,0,.814.814H31.436a.815.815,0,0,0,.814-.814V22.011a1.25,1.25,0,1,1,2.5,0v8.738A3.318,3.318,0,0,1,31.436,34.063Z"></path>
              </svg>
            </span>
          </button>
        </CSVLink>
      </div>

      <div className="items-and-dues">
        <select className="items-per-page-select" value={rowsPerPage} onChange={handleItemsPerPageChange}>
          <option value={10}>10 items per page</option>
          <option value={50}>50 items per page</option>
          <option value={75}>75 items per page</option>
        <option value={100}>100 items per page</option>
      </select>
      <div className="pagination-selector">
          <div className="button-group">
            <div className="group-label">Items per page:</div>
            <div className="button-options">
              {[10, 50, 75, 100].map((option) => (
                <button
                  key={option}
                  onClick={() =>
                    handleItemsPerPageChange({ target: { value: option } })
                  }
                  className={`page-button ${rowsPerPage === option ? 'active' : ''}`}
                >
                  <span className="button-text">{option}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
        <button className="tt-action-btn" onClick={fetchCheckinReports}>
          <FiRefreshCw className={`refresh-icon ${loading ? 'spin' : ''}`} />
          Refresh
        </button>
      </div>

      {loading && (
        <div className="premium-loader">
          <div className="progress-track">
            <div className="progress-bar"></div>
          </div>
          <div className="status-text">
            <span>L</span>
            <span>O</span>
            <span>A</span>
            <span>D</span>
            <span>I</span>
            <span>N</span>
            <span>G</span>
          </div>
        </div>
      )}
      {error && <div className="error-message">{error}</div>}
      {!loading && !error && filteredCheckinReports.length === 0 && (
        <div className="error-message">No data available</div>
      )}

      
      <div className="tt-table-container">
        <table className="tt-table">
          <thead>
            <tr>
              {headers.map(({ key, label }) => (
                <th key={key} className="challenges-column" onClick={() => handleSort(key)}>
                  <div className="th-content">
                    <span>{label}</span>
                    <FiChevronDown
                      className={`sort-icon ${sortConfig.key === key ? 'active' : ''
                        } ${sortConfig.key === key && sortConfig.direction === 'descending' ? 'desc' : ''}`}
                    />
                  </div>
                </th>
              ))}
            </tr>
          </thead>


          <tbody>
          {currentRows.map((checkin) => (
              <tr key={checkin.id}>
                <td>{checkin.preferredCenter}</td>
                <td>{checkin.player_name}</td>
                <td>{checkin.phoneNumber}</td>
                <td>{checkin.parentPhoneNumber}</td>
                <td>{checkin.type}</td>
                <td>{new Date(checkin.date).toLocaleDateString('en-GB')}</td>
                <td>{checkin.time}</td>
                <td>{checkin.remark}</td>
                <td>{checkin.sport}</td>
                <td>{checkin.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="pagination">
        <div className="showing-entries">
          Showing {indexOfFirstEntry} to {indexOfLastEntry} of {totalEntries} entries
        </div>
        <button
          className="prev-button"
          onClick={handlePrevPage}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        {renderPagination()}
        <button
          className="next-button"
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default CheckinReports;
